var render = function render(_c,_vm){return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":true,"z-index":999,"opacity":0.5,"color":"white"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":130,"width":2}},[_vm._v(" Loading... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }